import type { ContextualFormattingEnabledOptions } from '@atlaskit/editor-common/toolbar';
import type { ToolbarPluginOptions } from '@atlaskit/editor-plugin-toolbar';

interface Props {
	options: {
		/** @see ToolbarPluginOptions.componentFilter (EDITOR-6558) */
		componentFilter?: ToolbarPluginOptions['componentFilter'];
		contextualFormattingEnabled?: ContextualFormattingEnabledOptions;
	};
}

export function toolbarPluginOptions({ options }: Props): ToolbarPluginOptions {
	return {
		componentFilter: options.componentFilter,
		contextualFormattingEnabled: options.contextualFormattingEnabled,
	};
}
